<template>
        <PWAPromptAndro/>
  <PWAPromptios :copyBody="'Add Palaxi Cinemas to your homescreen'" />
            <nav class="mobile-menu" style="display: block; background: #111111e6;" :class="{ active: isMenuOpen }">
            <div class="inner">

                <!-- end mobile-search -->
                <a  data-toggle="modal" data-target="#largeModall" class="button-account" style="height: 50px;border-radius: 8px;background: linear-gradient(135deg, rgba(174,1,94,1) 1%,rgba(222,12,100,1) 16%,rgba(235,18,89,1) 30%,rgba(239,82,69,1) 67%,rgba(244,121,45,1) 83%,rgba(254,187,23,1) 100%);
line-height: 50px;color: #fff;" v-if=!loginCode><i class="lni lni-user" style="width: 30px;
height: 30px;
line-height: 24px;color: aliceblue;
font-size: 17px;"></i> LOGIN </a>
<router-link to="/user" class="button-account" style="height: 50px;border-radius: 8px;background: linear-gradient(135deg, rgba(174,1,94,1) 1%,rgba(222,12,100,1) 16%,rgba(235,18,89,1) 30%,rgba(239,82,69,1) 67%,rgba(244,121,45,1) 83%,rgba(254,187,23,1) 100%);
line-height: 50px;color: #fff;" v-if=loginCode @click="toggleMenu"><i class="lni lni-user" style="width: 30px;
height: 30px;
line-height: 24px;color: aliceblue;
font-size: 17px;"></i>PROFILE</router-link>
                <!-- end button-account -->
                <div class="site-menu">
                    <ul>
                        <li><router-link to="/index" style="font-size: 5vw;" @click="toggleMenu">HOME</router-link></li>
                        <li><router-link to="/about" style="font-size: 5vw;" @click="toggleMenu">ABOUT US </router-link></li>
                        <li><router-link to="/contactus" style="font-size: 5vw;" @click="toggleMenu">CONTACT US</router-link></li>
                    </ul>
                </div>
                <!-- end site-menu -->
            </div>
            <!-- end inner -->
        </nav>
        <!-- end mobile-menu -->
        <nav class="navbar" style="padding-top: 6px !important;position: absolute !important;">
            <div class="logo"> <a href="#"> <img :src="imgPath+'images/logo.png'" alt="Image" style="height: 55px;"> </a> </div>
            <!-- end logo -->
            <div class="site-menu">
                <ul>
                    <li><router-link to="/index" >HOME</router-link></li>
        <li><router-link to="/about" >ABOUT US</router-link></li>
        <li><router-link to="/index#movies">MOVIES</router-link></li>
        <!--      <li><a href="#">
SHOW TIMES </a></li> -->
        <li><router-link to="/index#movies"> COMING SOON </router-link></li>
        <li><router-link to="/contactus">CONTACT US</router-link></li>
                </ul>
            </div>
            <!-- end site-menu -->
            <div class="user-menu">

                <!-- end navbar-search -->
                <!-- end navbar-notify -->
                <div class="navbar-account"> <a href="profile.html">Login <i class="lni lni-user"></i> </a></div>
                <!-- end navbar-account -->
            </div>
            <!-- end user-menu -->
            <div class="hamburger-menu">
                <button class="hamburger" :class="{ opened: isMenuOpen }" @click="toggleMenu">
                    <svg width="45" height="45" viewBox="0 0 100 100">
                        <path class="line line1"
                            d="M 20,29.000046 H 80.000231 C 80.000231,29.000046 94.498839,28.817352 94.532987,66.711331 94.543142,77.980673 90.966081,81.670246 85.259173,81.668997 79.552261,81.667751 75.000211,74.999942 75.000211,74.999942 L 25.000021,25.000058" />
                        <path class="line line2" d="M 20,50 H 80" />
                        <path class="line line3"
                            d="M 20,70.999954 H 80.000231 C 80.000231,70.999954 94.498839,71.182648 94.532987,33.288669 94.543142,22.019327 90.966081,18.329754 85.259173,18.331003 79.552261,18.332249 75.000211,25.000058 75.000211,25.000058 L 25.000021,74.999942" />
                    </svg>
                </button >
            </div>
            <!-- end hamburger-menu -->
        </nav>
<modal></modal>

</template>
<script>
import modal from "../UI/LoginModal.vue";
import PWAPromptAndro  from "./PWAPrompt.vue";
import PWAPromptios from 'vue2-ios-pwa-prompt';
export default {
    components:{
        modal,
        PWAPromptAndro,
    PWAPromptios
    },
    data() {
    return {
      imgPath: process.env.BASE_URL,
      isMenuOpen:false,
      loginCode:localStorage.getItem("loginCode"),


    }},
    methods:{
        toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      document.body.classList.toggle("overflow");
    },
    }
  
};
</script>